import { ParallaxSection } from '@web/components/ParallaxSection'
import { SubHeroInternal } from '@web/components/SubHeroInternal'
import TeamComponent from '@web/components/TeamComponent'
import ValuesSection from '@web/components/ValuesSection'
import ContactSection from '../sections/ContactSection'
import JobVacanciesCTA from '../sections/CTA/JobVacanciesCTA'
import { Hero } from '../sections/Hero/Hero'
import UrbanIntelligenceSection from '../sections/UrbanIntelligenceSection'

const TeamPage = () => {
  return (
    <>
      <Hero isInternalPage={true} waveColor="#0b2948" />
      <SubHeroInternal>
        <h1 className="font-light text-h1Light text-text-inverted text-balance ">
          Urban Intelligence<sup className="text-3xl">®</sup> is the power behind Resilience
          Explorer<sup className="text-3xl">®</sup>{' '}
        </h1>
        <h1 className="font-light text-h1 text-text-inverted text-balance ">
          A software, research, and advisory team{' '}
          <strong>accelerating evidence-based resilience.</strong>
        </h1>
      </SubHeroInternal>
      <UrbanIntelligenceSection />
      <TeamComponent />
      <ParallaxSection
        height="h-auto"
        image="/website/ui-values-bg.webp"
        overlayOpacity="bg-black/30"
      >
        <div className="flex items-center justify-center w-full h-full py-20">
          <ValuesSection />
        </div>
      </ParallaxSection>
      <JobVacanciesCTA />
      <ContactSection isInternalPage={true} />
    </>
  )
}

export default TeamPage
